import { NgModule } from '@angular/core';

import { PopoverDirective } from './popover.directive';

@NgModule({
    declarations: [PopoverDirective],
    exports: [PopoverDirective],
})
export class PopoverModule {}
